import { Button, Spinner } from "reactstrap";
import { WalletBody, walletDetailsStyles } from "./styles";
import { Typography } from "@mui/material";
import { WalletDetailsProps } from "./types";
import { FONT_FAMILY } from "../../theme";

const WalletDetails: React.FC<WalletDetailsProps> = ({
  connectedWallet,
  wBalance,
  isWithdrawing,
  withdrawBalance,
}) => {
  return (
    <div style={{ fontFamily: FONT_FAMILY }} className="container-earn">
      <WalletBody>
        <div className="wallet-container">
          <div>Wallet Address</div>
          <div className="code">
            {connectedWallet
              ? `${connectedWallet.slice(0, 10)}...${connectedWallet.slice(
                  -10
                )}`
              : ""}
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{ fontFamily: FONT_FAMILY }}
            className="balance-container"
          >
            <div style={{ marginBottom: 8 }}>Withdrawable Balance</div>
            <div>{`${wBalance} ETH`}</div>
          </div>
          <Button
            className="withdraw-button"
            type="submit"
            disabled={Number(wBalance) < 0.0001 || isWithdrawing}
            sx={walletDetailsStyles.WithdrawBalanceButton}
            onClick={() => {
              withdrawBalance();
            }}
          >
            {isWithdrawing ? (
              <>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  color="black"
                />{" "}
                <Typography
                  variant="h1"
                  sx={{ fontFamily: FONT_FAMILY, fontSize: 20 }}
                >
                  Withdrawing...
                </Typography>
              </>
            ) : (
              <Typography
                variant="h1"
                sx={walletDetailsStyles.WithdrawBalanceTypography}
              >
                Withdraw Balance
              </Typography>
            )}
          </Button>
        </div>
      </WalletBody>
    </div>
  );
};

export default WalletDetails;
